/**
 * Format a user object for display in the Users table
 */
export function formatUserForDisplay(user: any) {
  let displayBankName: string;

  if (user.user_type === "monitoring") {
    displayBankName = user.organization?.name || "მონიტორინგი";
  } else if (user.user_type === "admin") {
    displayBankName = "ადმინი";
  } else {
    displayBankName = "სააგენტო";
  }

  return {
    ...user,
    bankDisplay: displayBankName,
  };
}

/**
 * Determine the tab ("agency" | "monitoring") for a user
 */
export function getUserTab(userType: string): string {
  if (userType === "monitoring") return "monitoring";
  return "agency";
}

/**
 * Check if a tab should be disabled in the user dialog
 */
export function isTabDisabled(
  tabName: string,
  currentTab: string,
  isEditMode: boolean,
  isMonitoring: boolean
): boolean {
  // In edit mode only allow the current tab
  if (isEditMode) return tabName !== currentTab;
  // Monitoring users can only create monitoring users
  if (isMonitoring && tabName === "agency") return true;
  return false;
}

export const USER_TYPE_CHIP: Record<string, { label: string; color: "default" | "primary" | "secondary" | "error" }> = {
  agency:     { label: "სააგენტო",        color: "primary" },
  monitoring: { label: "მონიტ. კომპანია",  color: "secondary" },
  admin:      { label: "ადმინი",           color: "error" },
};

export const PERMISSION_LABEL: Record<string, string> = {
  USER_MANAGE:                  "მომხ. მართვა",
  MANAGE_MONITORING_COMPANIES:  "კომპ. მართვა",
  SUBMIT_MONITORING_FORMS:      "ფორმის წარდგ.",
  REVIEW_MONITORING:            "განხილვა",
  REASSIGN_APPLICATIONS:        "გადამისამართება",
  MANAGE_PAYMENTS:              "გადახდები",
  MANAGE_MONITORING_AGREEMENTS: "განაცხ. დამატება",
};
